<template>
  <div class="th_info">
    <div class="th_info_top">{{ $t("main.text309") }}</div>
    <div class="th_info_main">
      <div class="th_tit1">{{ $t("main.text309") }}</div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text310") }}</div>
        <div class="th_tit4">{{ overall_time(data_all.c_time) }}</div>
      </div>
      <div class="th_tit2">
        <!-- tx_type: 1加密货币 2法币 法币 那行为绿色文字 -->

        <div class="th_tit3" v-if="data_all.tx_type == 1">
          {{ $t("main.text326") }}
        </div>
        <div class="th_tit3" v-else>{{ $t("main.text326") }}</div>
        <div class="th_tit4">{{ data_all.tx_id }}</div>
      </div>

      <div class="th_tit1 title_bottom">{{ $t("main.text313") }}</div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text479") }}</div>
        <div class="th_tit4">
          <span>{{ data_all.type_name }}</span>
        </div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text282") }}</div>
        <div class="th_tit4">{{ data_all.token_type }}</div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text701") }}</div>
        <div class="th_tit4">{{ data_all.to_token_type }}</div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text314") }}</div>
        <div class="th_tit4">{{ set_num3_2(data_all.amount) }} {{ data_all.token_type }}</div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text793") }}</div>
        <div class="th_tit4">{{ data_all.receive == '-' ? data_all.receive : set_num3_2(data_all.receive) }}</div>
      </div>
      <div class="th_tit2" v-if="data_all.tx_type == 1">
        <!-- tx_type: 1加密货币 2法币 -->
        <!-- 加密货币充值 才会有这个 字段   法币充值 不需要有 sender sddress -->
        <div class="th_tit3">{{ $t("main.text315") }}</div>
        <div class="th_tit4">{{ data_all.from_addr }}</div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text316") }}</div>
        <div class="th_tit4">
          <!-- 状态: 20 成功 21 审核中 22 审核失败; 23交易中；24交易失败 25 待审核 -->
          <span v-if="data_all.status == 20">{{ $t("main.text317") }}</span>
          <span v-else-if="data_all.status == 21">{{
            $t("main.text318")
          }}</span>
          <span v-else-if="data_all.status == 22">{{
            $t("main.text319")
          }}</span>
          <span v-else-if="data_all.status == 23">{{
            $t("main.text320")
          }}</span>
          <span v-else-if="data_all.status == 24">{{
            $t("main.text321")
          }}</span>
          <span v-else-if="data_all.status == 25">{{
            $t("main.text229")
          }}</span>
          <span v-else>-</span>
        </div>
      </div>
      <div class="th_tit2">
        <div class="th_tit3">{{ $t("main.text735") }}</div>
        <div class="th_tit4">{{ data_all.card_number }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { transaction_get } from "@/api/api";
export default {
  data() {
    return {
      info_hash_tx_id: "",
      info_id: "",
      data_all: "",
    };
  },
  created() {
    this.info_hash_tx_id = sessionStorage.getItem("my_info_tx_id");
    this.info_id = sessionStorage.getItem("my_info_id");
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
    sessionStorage.removeItem("my_info_id");
  },
  mounted() {
    sessionStorage.setItem(
      "top_title_name",
      this.info_hash_tx_id == "-" ? "" : this.info_hash_tx_id
    );
    this.get_list();
  },
  methods: {
    get_list() {
      transaction_get({ id: this.info_id }).then((res) => {
        if (res.data.code == 200) {
          this.data_all = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.th_info {
  background: #232a36;
  border-radius: 16px;
}
.th_info_top {
  box-sizing: border-box;
  padding: 28px;
  border-bottom: 1.5px solid #191e29;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
}
.th_info_main {
  box-sizing: border-box;
  padding: 28px;
}
.th_tit1 {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 12px;
}
.th_tit2 {
  margin-bottom: 12px;
  display: flex;
}
.th_info_main .th_tit2:last-child {
  margin-bottom: 0;
}
.th_tit3 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  width: 160px;
  margin-right: 28px;
  display: inline-block;
}
.th_tit4 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  display: inline-block;
}
.title_bottom {
  margin-top: 30px;
}
</style>